import { AppState } from "@/mk2/reducers";

import {
    BlogsShortMessageDetailState,
    initialBlogsShortMessageDetailState,
} from "./BlogsShortMessageDetail.reducers";

export const getBlogsShortMessageDetailState = (
    state: AppState,
    username: string,
    postSlug: string,
): BlogsShortMessageDetailState =>
    state.containers.blogs.blogsShortMessageDetails[`${username}/${postSlug}`] ||
    initialBlogsShortMessageDetailState;
